import { useMutation } from "@apollo/client";
import {
  AddOrderProductsDocument,
  GetOrderByIdDocument,
} from "../../gql/generated/graphql";
import {
  createProductArgsToInput,
  type CreateProductArgs,
} from "../products/productInputs";

interface Props {
  orderId: string;
}

export const useAddOrderProducts = ({ orderId }: Props) => {
  const [addOrderProductsMutation, { loading }] = useMutation(
    AddOrderProductsDocument,
    {
      refetchQueries: [GetOrderByIdDocument],
      awaitRefetchQueries: true,
    }
  );

  const addOrderProducts = (products: CreateProductArgs[]) =>
    addOrderProductsMutation({
      variables: {
        orderId,
        products: products.map(createProductArgsToInput),
      },
    });

  return {
    addOrderProducts,
    loading,
  };
};
